
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tu-khoa/[...slug]",
      function () {
        return require("private-next-pages/tu-khoa/[...slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tu-khoa/[...slug]"])
      });
    }
  